import { Injectable, Injector } from "@angular/core";
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { from, lastValueFrom, Observable, retry, timer } from "rxjs";
import { DialogService } from "common/dialog/dialog.service";
import { catchError } from "rxjs/operators";

const LOCKED_STATUS_CODE = 423;
const LOCKED_AUTOMATIC_RETRIES = 1;
const LOCKED_AUTOMATIC_DELAY = 3000;

@Injectable({
	providedIn: "root",
})
export class StagesLockedHttpInterceptor implements HttpInterceptor {
	private readonly dialogService: DialogService;

	constructor(injector: Injector) {
		this.dialogService = injector.get<DialogService>(DialogService);
	}

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		return next.handle(request).pipe(
			retry({ count: LOCKED_AUTOMATIC_RETRIES, delay: this.shouldRetryAutomatic }),
			catchError((error: HttpErrorResponse) => from(this.handleError(request, next, error))),
		);
	}

	private shouldRetryAutomatic(error: HttpErrorResponse): Observable<number> {
		if (error.status === LOCKED_STATUS_CODE) {
			return timer(LOCKED_AUTOMATIC_DELAY);
		}
		throw error;
	}

	private async handleError(
		request: HttpRequest<unknown>,
		next: HttpHandler,
		error: HttpErrorResponse,
	): Promise<HttpEvent<unknown>> {
		if (error.status === LOCKED_STATUS_CODE) {
			const shouldRetryManual = await this.dialogService.confirm(
				"error.retry.message",
				undefined,
				"error.retry",
				"cancel",
			);
			if (shouldRetryManual) {
				return lastValueFrom(this.intercept(request, next));
			}
			location.reload();
			// eslint-disable-next-line @typescript-eslint/no-empty-function -- needed
			return new Promise<HttpEvent<unknown>>(() => {});
		}
		// eslint-disable-next-line @typescript-eslint/no-throw-literal -- defined by input parameter
		throw error;
	}
}
